"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagPF = function FlagPF(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,75.74H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06H-185.94A7.06,7.06,0,0,1-193,139.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H209.54a7.06,7.06,0,0,1,7.06,7.06v63.56H-193v-63.56a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "71.62",
    width: "409.6",
    height: "127.12",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M58.35-5.86,13.53,12.45l-.06-.14L56.76-9.37a50.3,50.3,0,0,0-6.2-9.53L13.23,12s-.05-.1-.1-.14L47.35-22.43a50.56,50.56,0,0,0-8-6.53L12.82,11.59a1.13,1.13,0,0,0-.18-.12L34.28-31.85a49.76,49.76,0,0,0-11.06-4l-11,47.17a2,2,0,0,0-.43-.08,2.17,2.17,0,0,0-.43.08L.38-35.84a49.76,49.76,0,0,0-11.06,4L11,11.47l-.18.12L-15.71-29a50.56,50.56,0,0,0-8,6.53L10.47,11.82s-.06.1-.1.14L-27-18.9a50.3,50.3,0,0,0-6.2,9.53L10.13,12.31l-.06.14L-34.75-5.86a50.15,50.15,0,0,0-3,10.43L10,12.84A.42.42,0,0,0,10,13l-48.17-5a49,49,0,0,0-.27,5.17A50.46,50.46,0,0,0-37.68,22L11.8,16.83,61.28,22a50.46,50.46,0,0,0,.79-8.84,49,49,0,0,0-.27-5.17L13.63,13a.42.42,0,0,0,0-.12L61.33,4.57a49.55,49.55,0,0,0-3-10.43Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffb955"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-36.79,26c.35,1.3.75,2.58,1.19,3.84H59.2c.44-1.26.84-2.54,1.19-3.84-4.65-.6-5.23-3.61-10.88-3.61-6.28,0-6.28,3.72-12.56,3.72s-6.29-3.72-12.57-3.72-6.28,3.72-12.56,3.72S5.53,22.42-.74,22.42-7,26.14-13.31,26.14s-6.29-3.72-12.58-3.72c-5.67,0-6.24,3-10.9,3.61Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48,35.45c-6.05,0-6.05-3.72-12.1-3.72s-6.05,3.72-12.1,3.72-6-3.72-12.1-3.72-6,3.72-12.09,3.72-6-3.72-12.1-3.72-6.05,3.72-12.1,3.72c-5.37,0-6-2.92-10.28-3.58a50.86,50.86,0,0,0,3.65,7.31h86a51.14,51.14,0,0,0,3.66-7.33c-4.42.62-5,3.6-10.42,3.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.83,42.13A9.55,9.55,0,0,0,48.11,41c-6,0-6,3.72-12.1,3.72S30,41,23.91,41s-6,3.72-12.09,3.72S5.77,41-.28,41s-6,3.72-12.1,3.72S-18.44,41-24.49,41a9.48,9.48,0,0,0-4.74,1.1,51.18,51.18,0,0,0,5.32,6.34H47.51a50.55,50.55,0,0,0,5.32-6.35Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.78,52.69c-1.83-1.06-3.3-2.34-6.85-2.34-6.05,0-6.05,3.72-12.1,3.72s-6-3.72-12.1-3.72-6,3.72-12.09,3.72-6-3.72-12.1-3.72c-3.5,0-5,1.24-6.77,2.29a49.68,49.68,0,0,0,8,5.15h46a50.1,50.1,0,0,0,8-5.1Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.28,59.66a9.73,9.73,0,0,0-4.42.93,50.09,50.09,0,0,0,16.5,2.79h0c-6,0-6-3.72-12.09-3.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.84,63.38a50.18,50.18,0,0,0,16.48-2.79,9.54,9.54,0,0,0-4.4-.93c-6,0-6.06,3.7-12.08,3.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.41,6.75,2.48,2.14A2.1,2.1,0,0,1,1,.14C.89-5.75.63-26.52.63-29.71.63-33.43,4.35-39,11.8-39h5.87a.51.51,0,0,1,.22,1c-2.69,1.16-6.09,3.56-6.09,8.34,0,5.67,5.4,8.1,8,8.94a1.92,1.92,0,0,1,1.33,1.82V4.72a2.12,2.12,0,0,1-2.7,2Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.36,27.58a.7.7,0,0,1,1,.87C3.82,32.2,0,39.18-6.82,39.18c-9.31,0-11.17-7.45-11.17-13V-13.35a1.47,1.47,0,0,1,1.47-1.47h2.64a1.47,1.47,0,0,1,1.47,1.47V24.28c0,5,10.59,7,16.77,3.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.46,27.58a.71.71,0,0,0-1,.87C19,32.2,22.82,39.18,29.64,39.18c9.31,0,11.17-7.45,11.17-13V-13.35a1.47,1.47,0,0,0-1.47-1.47H36.69a1.47,1.47,0,0,0-1.47,1.47V24.28c0,5-10.58,7-16.76,3.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M31.38,21.49H-7.78a.9.9,0,0,1-.9-.9v-.07a.9.9,0,0,1,.9-.9H31.38a.9.9,0,0,1,.9.9v.07a.9.9,0,0,1-.9.9Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-4.72,14.46l2-2.69a.92.92,0,0,0-.19-1.3.93.93,0,0,0-1.3.19l-.78,1V11a.93.93,0,0,0-.93-.93.92.92,0,0,0-.93.93v.65l-.74-1a.93.93,0,0,0-1.3-.19.93.93,0,0,0-.19,1.3l2,2.69-2,2.69a.93.93,0,0,0,.19,1.3.88.88,0,0,0,.56.19.93.93,0,0,0,.74-.37L-5.89,16l1.69,2.26a.93.93,0,0,0,.74.37.9.9,0,0,0,.56-.19.93.93,0,0,0,.19-1.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.65,14.46l2-2.69a.93.93,0,0,0-1.49-1.11l-.79,1V11a.93.93,0,0,0-1.86,0v.65l-.73-1a.93.93,0,1,0-1.49,1.11l2,2.69-2,2.69a.93.93,0,0,0,.19,1.3.88.88,0,0,0,.55.19,1,1,0,0,0,.75-.37L11.49,16l1.69,2.26a.93.93,0,0,0,1.48-1.12Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,14.46l2-2.69a.93.93,0,1,0-1.49-1.11l-.78,1V11a.94.94,0,0,0-1.87,0v.65l-.73-1a.93.93,0,0,0-1.3-.19.92.92,0,0,0-.19,1.3l2,2.69-2,2.69a.92.92,0,0,0,.19,1.3.88.88,0,0,0,.55.19.93.93,0,0,0,.75-.37L2.8,16l1.69,2.26a.93.93,0,0,0,.74.37.9.9,0,0,0,.56-.19A.94.94,0,0,0,6,17.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.34,14.46l2-2.69a.93.93,0,0,0-1.49-1.11l-.79,1V11a.93.93,0,0,0-1.86,0v.65l-.73-1a.94.94,0,0,0-1.31-.19.93.93,0,0,0-.18,1.3l2,2.69-2,2.69a.93.93,0,1,0,1.48,1.12L20.18,16l1.68,2.26a1,1,0,0,0,.75.37.93.93,0,0,0,.74-1.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M30,14.46l2-2.69a.93.93,0,0,0-1.5-1.11l-.78,1V11a.93.93,0,0,0-1.86,0v.65l-.73-1a.94.94,0,0,0-1.31-.19.93.93,0,0,0-.18,1.3l2,2.69-2,2.69a.93.93,0,0,0,.18,1.3.9.9,0,0,0,.56.19.93.93,0,0,0,.74-.37L28.86,16l1.69,2.26a1,1,0,0,0,.75.37.88.88,0,0,0,.55-.19.92.92,0,0,0,.19-1.3Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-6.44,27.24c1.37.6,9.46.69,11.53-1.46s1.63-3.1,1.63-3.1l-9.81.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.65,27.24c-1.38.6-9.47.69-11.53-1.46s-1.64-3.1-1.64-3.1l9.81.09Zm0,0",
    transform: "translate(194 123)",
    fill: "#aa4650"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagPF;
exports["default"] = _default;